
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { Meta, MetaInfo } from '@/decorators';
	import { PagePermissionEnum } from '@/types/enum/PermissionEnum';

	/**
	 * Homepage destinée à rediriger l'utilisateur sur une page en fonction de son rôle.
	 */
	@Component
	export default class Home extends Vue {
		created() {
			let name = '';

			if (this.$can(PagePermissionEnum.PAYMENTS_LIST_PCR)) {
				name = 'paymentsPcr';
			}

			if (this.$can(PagePermissionEnum.PAYMENTS_LIST_DGOS)) {
				name = 'paymentsDgos';
			}

			if (this.$can(PagePermissionEnum.PAYMENTS_LIST_EXP)) {
				name = 'paymentsExp';
			}

			if (this.$can(PagePermissionEnum.EXPORTS_EVAL_DM)) {
				name = 'exportsEvaluationDM';
			}

			if (this.$can(PagePermissionEnum.EXPORTS_EVAL_TC)) {
				name = 'exportsEvaluationTC';
			}

			if (this.$can(PagePermissionEnum.EXPERIENCE_PATIENT_ADMINISTRATION)) {
				name = 'surveyCampaignAccessMaster';
			}

			if (this.$can(PagePermissionEnum.PROJECT_LIST)) {
				name = 'projects';
			}

			this.$router.push({ name });
		}

		/* istanbul ignore next */
		@Meta
		metaInfo(): MetaInfo {
			return {
				title: this.$t('views.home.meta.title') as string,
				meta: [
					{
						name: 'description',
						content: this.$t('views.home.meta.description') as string
					}
				]
			};
		}
	}
